import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
    className?: string;
}

export default function MainHeading({ children, className }: Props) {
    return (
        <h1
            className={`text-[#003295] dark:text-[#93B4D3] font-semibold sm:text-2xl text-xl lg:text-[32px] leading-[120%] tracking-normal text-center ${className}`}
        >
            {children}
        </h1>
    );
}
